export { default } from "./nodeLabel";
